import React from "react";
import ArchivePoslovniProcesi from "../../components/admin/archiveProcesses";

function ArchiveProcessesPage(props) {
  return (
    <div className="admin-page-child-wrapper">
      <ArchivePoslovniProcesi />
    </div>
  );
}

export default ArchiveProcessesPage;
